export default __webpack_public_path__ + "static/media/Green0007.afcabfc2.png";